import { notificationsActions } from 'redux/notifications/notificationsSlice'
import DropdownV2 from 'core-system/Dropdown/DropdownV2'
import { SelectItemProps } from 'core-system/Dropdown'
import LinkIcon from 'core-system/Icons/Actions/Link'
import OverflowIcon from 'core-system/Icons/Misc/Overflow'
import Table, { TableRow, TableRowCell } from 'core-system/Table'
import Text from 'core-system/Text'
import palette from 'core-system/Themes/palette'
import ToggleWorksiteInviteCodeModal from 'features/Accounts/Users/ToggleWorksiteInviteCodeModal'
import React, { useCallback, useEffect, useState } from 'react'
import { useDispatch } from 'react-redux'
import SegmentService from 'redux/config/services/SegmentService'
import { Worksite } from 'redux/employer/employerTypes'
import RandomUtils from 'shared/RandomUtils'
import styled from 'styled-components'
import ArchiveWorksiteModal from './ArchiveWorksiteModal'
import UnarchiveWorksiteModal from './UnarchiveWorksiteModal'
import EditWorksiteModal from './EditWorksiteModal'
import { useSelector } from 'react-redux'
import { AppState } from 'redux/config/store'
import moment from 'moment'
import EmployeesIcon from 'core-system/Icons/Misc/Employees'
import LocationIcon from 'core-system/Icons/Misc/Location'
import FlexContainer from 'core-system/FlexContainer'
import AddWorksiteModal from './AddWorksiteModal'
import PageHeader from '../components/PageHeader'
import PageBodyContainer from '../components/PageBodyContainer'
import ColorPill from 'core-system/Pill/ColorPill'
import PillContainer from 'core-system/Pill/Pill'
import { getAllProgramForColumn } from '../helperFunctions'
import InviteUsersModal from '../components/InviteUsersModal'
import SegmentInfoDrawer from './SegmentInfoDrawer'
import SegmentsDisplay from 'features/Programs/Shared/components/SegmentsDisplay'
import wordings from 'features/Programs/Shared/wordings.json'
import SegmentOperations from './SegmentOperations'

// Hardcoded worksites matching Compliance page data
const mockWorksites: Worksite[] = [
  {
    id: '1',
    alias: 'ATL - Airport Operations',
    address: '6000 N Terminal Pkwy',
    formattedAddress: '6000 N Terminal Pkwy, Atlanta, GA 30320',
    city: 'Atlanta',
    segmentId: 'seg-1',
    employeeCount: 1320,
    employeeArchivedCount: 0,
    archived: false,
    inviteCode: 'DELTA001',
    finchWorksite: null,
    archiveDate: null,
    currency: 'USD',
    lat: 33.6407,
    lng: -84.4277,
  },
  {
    id: '2',
    alias: 'ATL - HQ',
    address: '1030 Delta Blvd',
    formattedAddress: '1030 Delta Blvd, Atlanta, GA 30354',
    city: 'Atlanta',
    segmentId: 'seg-2',
    employeeCount: 952,
    employeeArchivedCount: 0,
    archived: false,
    inviteCode: 'DELTA002',
    finchWorksite: null,
    archiveDate: null,
    currency: 'USD',
    lat: 33.658,
    lng: -84.4,
  },
  {
    id: '3',
    alias: 'ATL - RES',
    address: '1020 Delta Blvd',
    formattedAddress: '1020 Delta Blvd, Atlanta, GA 30354',
    city: 'Atlanta',
    segmentId: 'seg-3',
    employeeCount: 392,
    employeeArchivedCount: 0,
    archived: false,
    inviteCode: 'DELTA003',
    finchWorksite: null,
    archiveDate: null,
    currency: 'USD',
    lat: 33.6585,
    lng: -84.401,
  },
  {
    id: '4',
    alias: 'ATL - TOP',
    address: '1775 M H Jackson Service Rd',
    formattedAddress: '1775 M H Jackson Service Rd, Atlanta, GA 30354',
    city: 'Atlanta',
    segmentId: 'seg-4',
    employeeCount: 592,
    employeeArchivedCount: 0,
    archived: false,
    inviteCode: 'DELTA004',
    finchWorksite: null,
    archiveDate: null,
    currency: 'USD',
    lat: 33.652,
    lng: -84.418,
  },
  {
    id: '5',
    alias: 'BOS - Airport Operations',
    address: '1 Harborside Dr',
    formattedAddress: '1 Harborside Dr, Boston, MA 02128',
    city: 'Boston',
    segmentId: 'seg-5',
    employeeCount: 328,
    employeeArchivedCount: 0,
    archived: false,
    inviteCode: 'DELTA005',
    finchWorksite: null,
    archiveDate: null,
    currency: 'USD',
    lat: 42.3656,
    lng: -71.0096,
  },
  {
    id: '6',
    alias: 'DTW - Airport Operations',
    address: '1 Renaissance Center',
    formattedAddress: '1 Renaissance Center, Detroit, MI 48243',
    city: 'Detroit',
    segmentId: 'seg-6',
    employeeCount: 536,
    employeeArchivedCount: 0,
    archived: false,
    inviteCode: 'DELTA006',
    finchWorksite: null,
    archiveDate: null,
    currency: 'USD',
    lat: 42.329,
    lng: -83.0398,
  },
  {
    id: '7',
    alias: 'JFK - Airport Operations',
    address: 'Building 144, JFK International Airport',
    formattedAddress:
      'Building 144, JFK International Airport, Jamaica, NY 11430',
    city: 'Jamaica',
    segmentId: 'seg-7',
    employeeCount: 520,
    employeeArchivedCount: 0,
    archived: false,
    inviteCode: 'DELTA007',
    finchWorksite: null,
    archiveDate: null,
    currency: 'USD',
    lat: 40.6413,
    lng: -73.7781,
  },
  {
    id: '8',
    alias: 'LAX - Airport Operations',
    address: '6040 Avion Dr',
    formattedAddress: '6040 Avion Dr, Los Angeles, CA 90045',
    city: 'Los Angeles',
    segmentId: 'seg-8',
    employeeCount: 520,
    employeeArchivedCount: 0,
    archived: false,
    inviteCode: 'DELTA008',
    finchWorksite: null,
    archiveDate: null,
    currency: 'USD',
    lat: 33.944,
    lng: -118.401,
  },
  {
    id: '9',
    alias: 'LGA - Airport Operations',
    address: 'Grand Central Pkwy',
    formattedAddress: 'Grand Central Pkwy, Flushing, NY 11371',
    city: 'Flushing',
    segmentId: 'seg-9',
    employeeCount: 328,
    employeeArchivedCount: 0,
    archived: false,
    inviteCode: 'DELTA009',
    finchWorksite: null,
    archiveDate: null,
    currency: 'USD',
    lat: 40.7769,
    lng: -73.874,
  },
  {
    id: '10',
    alias: 'MSP - Airport Operations',
    address: '4300 Glumack Dr',
    formattedAddress: '4300 Glumack Dr, St Paul, MN 55111',
    city: 'St Paul',
    segmentId: 'seg-10',
    employeeCount: 568,
    employeeArchivedCount: 0,
    archived: false,
    inviteCode: 'DELTA010',
    finchWorksite: null,
    archiveDate: null,
    currency: 'USD',
    lat: 44.8848,
    lng: -93.2223,
  },
  {
    id: '11',
    alias: 'MSP - RES',
    address: '7500 Airline Dr',
    formattedAddress: '7500 Airline Dr, Minneapolis, MN 55450',
    city: 'Minneapolis',
    segmentId: 'seg-11',
    employeeCount: 352,
    employeeArchivedCount: 0,
    archived: false,
    inviteCode: 'DELTA011',
    finchWorksite: null,
    archiveDate: null,
    currency: 'USD',
    lat: 44.87,
    lng: -93.217,
  },
  {
    id: '12',
    alias: 'MSP - TOP',
    address: '7150 Humphrey Dr',
    formattedAddress: '7150 Humphrey Dr, Minneapolis, MN 55450',
    city: 'Minneapolis',
    segmentId: 'seg-12',
    employeeCount: 392,
    employeeArchivedCount: 0,
    archived: false,
    inviteCode: 'DELTA012',
    finchWorksite: null,
    archiveDate: null,
    currency: 'USD',
    lat: 44.876,
    lng: -93.21,
  },
  {
    id: '13',
    alias: 'SEA - Airport Operations',
    address: '17801 International Blvd',
    formattedAddress: '17801 International Blvd, Seattle, WA 98158',
    city: 'Seattle',
    segmentId: 'seg-13',
    employeeCount: 408,
    employeeArchivedCount: 0,
    archived: false,
    inviteCode: 'DELTA013',
    finchWorksite: null,
    archiveDate: null,
    currency: 'USD',
    lat: 47.4502,
    lng: -122.3088,
  },
  {
    id: '14',
    alias: 'SLC - Airport Operations',
    address: '776 N Terminal Dr',
    formattedAddress: '776 N Terminal Dr, Salt Lake City, UT 84122',
    city: 'Salt Lake City',
    segmentId: 'seg-14',
    employeeCount: 480,
    employeeArchivedCount: 0,
    archived: false,
    inviteCode: 'DELTA014',
    finchWorksite: null,
    archiveDate: null,
    currency: 'USD',
    lat: 40.7899,
    lng: -111.9791,
  },
  {
    id: '15',
    alias: 'SLC - RES',
    address: '260 N 2370 W',
    formattedAddress: '260 N 2370 W, Salt Lake City, UT 84116',
    city: 'Salt Lake City',
    segmentId: 'seg-15',
    employeeCount: 312,
    employeeArchivedCount: 0,
    archived: false,
    inviteCode: 'DELTA015',
    finchWorksite: null,
    archiveDate: null,
    currency: 'USD',
    lat: 40.781,
    lng: -111.964,
  },
]

const WorksiteInfo = styled.div`
  display: flex;
  flex-direction: column;
  overflow: hidden;
`

const TopContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  margin-bottom: 1.5rem;
`

const Alias = styled.div`
  ${(props) => props.theme.typography.action4}
  color: ${(props) => props.theme.palette.text.primary};
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
`

const WorksiteAddress = styled.div`
  ${(props) => props.theme.typography.body2}
  color: ${(props) => props.theme.palette.text.placeholder};
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
`

const InviteContainer = styled.div`
  display: flex;
  align-items: center;
  cursor: pointer;
  border-radius: 0.5rem;
  padding: 0 0.4375rem 0 0.25rem;

  &:hover {
    background-color: ${(props) => props.theme.palette.secondary.purple300};
  }
`

const IconContainer = styled.div`
  min-width: 1.5rem;
  display: flex;
  align-items: center;
`

const handleLinkClick = (
  e: React.MouseEvent<HTMLDivElement>,
  dispatch: any,
  worksite: Worksite,
  setSelectedWorksite: (worksite: Worksite) => void,
  setIsInviteModalOpen: (open: boolean) => void
) => {
  e.stopPropagation()
  if (worksite.inviteCode) {
    RandomUtils.copyInviteCode(worksite.address, worksite.inviteCode)
    dispatch(
      notificationsActions.generalPageInfo({
        title: 'Copied!',
        msg: 'Successfully coped to clipboard',
      })
    )
    SegmentService.track('openInvite-link-copy', {
      worksiteName: worksite.alias,
    })
  } else {
    setSelectedWorksite(worksite)
    setIsInviteModalOpen(true)
  }
}

const getTableRows = (
  allWorksites: Worksite[],
  onRowClick: (Worksite) => void,
  menuCallback: (item: SelectItemProps) => void,
  dispatch: any,
  setSelectedWorksite: (worksite: Worksite) => void,
  setIsInviteModalOpen: (open: boolean) => void,
  isEditDisabled: boolean
) => {
  return allWorksites.map((worksite: Worksite, idx: number) => {
    const selectItems = !worksite.archived
      ? [
          {
            id: '0',
            text: 'Edit Worksite Info',
            worksite: worksite,
            disabled: isEditDisabled,
          },
          {
            id: '1',
            text: 'Invite Commuters',
            worksite: worksite,
            disabled: false,
          },
          {
            id: '2',
            text: 'Disable Invite Code',
            worksite: worksite,
            disabled: !worksite.inviteCode && true,
          },
          {
            id: '3',
            text: 'Archive Worksite',
            worksite,
            disabled:
              worksite.finchWorksite !== null ||
              Boolean(worksite.hasFinchEmployees),
          },
        ]
      : [
          {
            id: '4',
            text: 'Unarchive Worksite',
            worksite,
            disabled: false,
          },
        ]
    return (
      <TableRow key={idx} isClickable={!worksite.archived}>
        <TableRowCell onClick={() => onRowClick(worksite)}>
          <WorksiteInfo>
            <Alias>{worksite.alias}</Alias>
            <WorksiteAddress>
              {worksite.formattedAddress.split(',')[0]}
            </WorksiteAddress>
          </WorksiteInfo>
        </TableRowCell>
        <TableRowCell onClick={() => onRowClick(worksite)}>
          <ColorPill
            color={worksite.archived ? 'gray' : 'green'}
            text={worksite.archived ? 'Archived' : 'Active'}
          />
        </TableRowCell>
        <TableRowCell onClick={() => onRowClick(worksite)}>
          <SegmentsDisplay
            segments={worksite?.programs?.map((program) => ({
              id: program,
              text: program,
              type: program,
            }))}
            displayType='table'
          />
        </TableRowCell>
        <TableRowCell onClick={() => onRowClick(worksite)}>
          <FlexContainer alignItems='center'>
            <LocationIcon />
            {worksite.city}
          </FlexContainer>
        </TableRowCell>
        <TableRowCell onClick={() => onRowClick(worksite)}>
          {worksite.currency ? (
            <PillContainer>{worksite.currency}</PillContainer>
          ) : (
            <Text variant='body2' textColor={palette.text.placeholder}>
              -
            </Text>
          )}
        </TableRowCell>
        <TableRowCell onClick={() => onRowClick(worksite)}>
          <FlexContainer alignItems='center'>
            <EmployeesIcon />
            {worksite.archived
              ? // This is a band-aid fix: when archiving a worksite with employees in staging, the archived employee count isn't getting updated
                // likely being caused by the get request happening before the bulk_archive_employees task is finished
                worksite.employeeArchivedCount + worksite.employeeCount
              : worksite.employeeCount}
          </FlexContainer>
        </TableRowCell>
        <TableRowCell style={{ width: '100px' }}>
          {worksite.archived ? (
            <> {moment(worksite.archiveDate).format('MMMM Do, YYYY')} </>
          ) : (
            <>
              <InviteContainer
                onClick={(e) =>
                  handleLinkClick(
                    e,
                    dispatch,
                    worksite,
                    setSelectedWorksite,
                    setIsInviteModalOpen
                  )
                }
              >
                <IconContainer>
                  <LinkIcon color={palette.text.secondary} />
                </IconContainer>
                <Text
                  variant='action4'
                  textColor={palette.text.secondary}
                  marginLeft='0.375rem'
                  hideOverflow
                  data-cy='accounts-worksite-table-invite-code'
                >
                  {worksite.inviteCode ? 'Copy Link' : 'Setup Invite Code'}
                </Text>
              </InviteContainer>
            </>
          )}
        </TableRowCell>
        <TableRowCell>
          <DropdownV2
            variant={'textual'}
            svgDropdown={true}
            usePortal={true}
            icon={<OverflowIcon />}
            active={null}
            items={selectItems}
            itemCallback={menuCallback}
            width={220}
            data-cy='accounts-worksite-table-dropdown'
          />
        </TableRowCell>
      </TableRow>
    )
  })
}

interface WorksiteViewProps {
  activeTab: number
  setActiveTab: (tab: number) => void
  tabs: { label: string; value: number }[]
}

const WorksiteView = React.memo((props: WorksiteViewProps) => {
  const { activeTab, setActiveTab, tabs } = props
  // Use hardcoded mock worksites instead of Redux state
  const allWorksites = mockWorksites
  const hrisStatus = useSelector((state: AppState) => ({
    providerName: state.employer.profile?.payrollProviderId,
    reauth: state.employer.profile?.finchReauth,
  }))

  const allFlexPrograms = useSelector(
    (state: AppState) => state.flex.flexPrograms
  )
  const allGrhPrograms = useSelector((state: AppState) => state.grh.grhPrograms)
  const allQtfPrograms = useSelector((state: AppState) => state.qtf.qtfPrograms)
  const allMicromobilityPrograms = useSelector(
    (state: AppState) => state.micromobility.micromobilityPrograms
  )

  const getWorksitesWithPrograms = () => {
    return allWorksites.map((worksite) => {
      return {
        ...worksite,
        programs: getAllProgramForColumn(
          allFlexPrograms,
          allGrhPrograms,
          allQtfPrograms,
          allMicromobilityPrograms,
          worksite.segmentId
        ),
      }
    })
  }

  const [workSitesToRender, setWorkSitesToRender] = useState(
    getWorksitesWithPrograms()
  )

  useEffect(() => {
    setWorkSitesToRender(getWorksitesWithPrograms())
  }, [allWorksites])

  const dispatch = useDispatch()
  const [modalOpen, setModalOpen] = React.useState<boolean>(false)
  const [selectedWorksite, setSelectedWorksite] = React.useState<Worksite>(null)
  const [isInviteModalOpen, setIsInviteModalOpen] = useState(false)
  const [isArchiveWorksiteModalOpen, setIsArchiveWorksiteModalOpen] =
    useState(false)
  const [isUnarchiveWorksiteModalOpen, setIsUnarchiveWorksiteModalOpen] =
    useState(false)
  const [isInviteCommutersModalOpen, setIsInviteCommutersModalOpen] =
    useState(false)
  const [isWorksiteInfoDrawerOpen, setIsWorksiteInfoDrawerOpen] =
    useState(false)

  const closeModal = useCallback(() => {
    setModalOpen(false)
    SegmentService.track('table-item-click', {
      tableType: 'worksites',
      action: 'close',
    })
  }, [])

  const menuCallback = (item: SelectItemProps) => {
    setSelectedWorksite(item.worksite)
    if (item.id === '0') {
      setModalOpen(true)
      SegmentService.track('table-item-click', {
        tableType: 'worksites',
        action: 'open',
        worksiteName: item.worksite && item.worksite.alias,
      })
    } else if (item.id === '1' && !item.disabled) {
      setIsInviteCommutersModalOpen(true)
    } else if (item.id === '2' && !item.disabled) {
      setIsInviteModalOpen(true)
    } else if (item.id === '3') {
      setIsArchiveWorksiteModalOpen(true)
    } else if (item.id === '4') {
      setIsUnarchiveWorksiteModalOpen(true)
    }
  }

  const [worksiteModalOpen, setWorksiteModalOpen] = useState(false)

  const openAddWorksiteModal = () => {
    setWorksiteModalOpen(true)
    SegmentService.track('addWorksite-modal-click', {
      action: 'open',
    })
  }

  const closeAddWorksiteModal = () => {
    setWorksiteModalOpen(false)
    SegmentService.track('addWorksite-modal-click', {
      action: 'close',
    })
  }

  const HeaderCell = (text: string) => (
    <TableRowCell>
      <Text fontWeight={600} variant={'action3'}>
        {text}
      </Text>
    </TableRowCell>
  )

  const headerCells = [
    HeaderCell('Worksite'),
    HeaderCell('Status'),
    HeaderCell('Programs'),
    HeaderCell('City'),
    HeaderCell('Currency'),
    HeaderCell('Commuters'),
    HeaderCell('Signed Up Commuters'),
    HeaderCell('Edit'),
  ]

  const getCityFilters = () => {
    const object = {
      header: 'City',
      checkboxes: [],
    }
    getWorksitesWithPrograms().forEach((worksite) => {
      if (
        !object.checkboxes.find((checkbox) => checkbox.label === worksite.city)
      ) {
        object.checkboxes.push({
          label: worksite.city,
          checked: false,
          key: 'city',
          value: worksite.city,
        })
      }
    })
    return object
  }

  const filters = [
    {
      header: 'Status',
      checkboxes: [
        { label: 'Active', checked: false, key: 'archived', value: false },
        { label: 'Archived', checked: false, key: 'archived', value: true },
      ],
    },
    {
      header: 'Programs',
      checkboxes: [
        {
          label: wordings.flex.title,
          checked: false,
          key: 'programs',
          value: wordings.flex.title,
        },
        {
          label: wordings.grh.title,
          checked: false,
          key: 'programs',
          value: wordings.grh.title,
        },
        {
          label: wordings.qtf.title,
          checked: false,
          key: 'programs',
          value: wordings.qtf.title,
        },
        {
          label: wordings.micromobility.title,
          checked: false,
          key: 'programs',
          value: wordings.micromobility.title,
        },
      ],
    },
    getCityFilters(),
  ]

  const onRowClick = (worksite: Worksite) => {
    if (worksite.archived) {
      return
    }
    // Only allow clicking on HQ (id '1') which has mock data
    if (worksite.id !== '1') {
      return
    }
    setSelectedWorksite(worksite)
    setIsWorksiteInfoDrawerOpen(true)
  }

  return (
    <>
      <PageHeader
        activeTab={activeTab}
        setActiveTab={setActiveTab}
        tabs={tabs}
        newGroupWorksiteButtonText='Create New Worksite'
        showCreateNewGroupButton
        createNewGroupWorksite={openAddWorksiteModal}
        isCreateNewGroupWorksiteDisabled={
          hrisStatus?.providerName ? true : false
        }
        newGroupWorksiteButtonTooltip={
          hrisStatus?.providerName
            ? 'You cannot create a new worksite while connected to a payroll provider through HRIS'
            : ''
        }
      />
      <PageBodyContainer>
        <TopContainer>
          <SegmentOperations
            filters={filters}
            searchArray={['alias', 'city', 'address']}
            segments={getWorksitesWithPrograms()}
            setFilteredSegments={setWorkSitesToRender}
            sortKey='alias'
          />
        </TopContainer>
        <Table
          headerCells={headerCells}
          rows={getTableRows(
            workSitesToRender,
            onRowClick,
            menuCallback,
            dispatch,
            setSelectedWorksite,
            setIsInviteModalOpen,
            hrisStatus?.providerName ? true : false
          )}
          stickyColumns={1}
        />
        {selectedWorksite && (
          <>
            <EditWorksiteModal
              worksite={selectedWorksite}
              open={modalOpen}
              closeModal={closeModal}
            />
            <ToggleWorksiteInviteCodeModal
              worksite={selectedWorksite}
              open={isInviteModalOpen}
              closeModal={() => setIsInviteModalOpen(false)}
            />
            <ArchiveWorksiteModal
              worksite={selectedWorksite}
              open={isArchiveWorksiteModalOpen}
              closeModal={() => setIsArchiveWorksiteModalOpen(false)}
            />
            <UnarchiveWorksiteModal
              worksite={selectedWorksite}
              open={isUnarchiveWorksiteModalOpen}
              closeModal={() => setIsUnarchiveWorksiteModalOpen(false)}
            />
            <InviteUsersModal
              segmentId={selectedWorksite.segmentId}
              closeModal={() => setIsInviteCommutersModalOpen(false)}
              open={isInviteCommutersModalOpen}
            />
            <SegmentInfoDrawer
              type='worksite'
              open={isWorksiteInfoDrawerOpen}
              closeModal={() => setIsWorksiteInfoDrawerOpen(false)}
              worksite={selectedWorksite}
            />
          </>
        )}
      </PageBodyContainer>
      <AddWorksiteModal
        open={worksiteModalOpen}
        closeModal={closeAddWorksiteModal}
      />
    </>
  )
})

// Helps to identify component in React error logs
if (process.env.NODE_ENV !== 'production') {
  WorksiteView.displayName = 'WorksiteView'
}

export default WorksiteView
